module.exports = __webpack_public_path__ + "static/media/billing.9cffdeae.svg";